
import { mapGetters, mapActions } from 'vuex';
import Grid from 'vux/src/components/grid/grid.vue'
import GridItem from 'vux/src/components/grid/grid-item.vue'

export default {
components: {
Grid,
GridItem
},
name: 'index',
data() {
return {
menu: [
{
name: '登录',
link: '/login'
},
{
name: '签名板',
link: '/write'
},
{
name: '图片合成',
link: '/imageSynthesis'
},
{
name: '地区选择',
link: '/regionSelect'
},
{
name: '上传图片',
link: '/imageView'
},
{
name: '上传视频',
link: '/videoView'
}
],
selectLength: {
start: 1,
length: 2
},
selectValue: {
province: ['610000'],
city: [''],
district: ['']
},
loginWords: {
label: ['用户名', '密码'],
placeHolder: ['请输入用户名', '请输入密码']
}
}
},
methods: {
...mapActions([
'AgetSendImage',
'getLogin',
'AgetCrf',
'AgetCollection'
]),
clearSelect() {
this.$refs.regionSelect.clearSelect();
},
reset() {
this.$refs.regionSelect.reset();
},
getResult() {
console.log(this.$refs.regionSelect.region)
console.log(this.$refs.regionSelect.getResult());
},
download() {
this.$refs.imageSynthesis.getRes(true, this.getImage);
},
getImage(blob, base64) {
console.log(blob)
console.log(base64)
},
getHandWrite(blob, base64) {
console.log(blob);
console.log(base64);
}
},
watch: {
},
computed: {
...mapGetters([
'crfcode',
'collection',
'baseURL'
])
},
created() {
},
mounted() {
}
};
